<template>
    <div>
            <div :style="{ backgroundImage: 'url(' + require('./assets/登陆背景2.png') + ')' }"
                style="width: 100%; height: 100%; background-size:cover">

                <div style="padding-top: 15%">
                    <div style="width: 18%; height: 300px; background-color:rgba(255,255,255,0.3);
                        margin-left: 70%; border-radius: 5px; box-shadow:0px 0px 0px #555555;">

                        <el-row>
                            <div style="text-align: center; font-size: 23px;color:#fff;padding:30px 0">欢迎登录</div>
                        </el-row>

                        <el-form :model="from" :rules="rules" ref="from" style="margin: 0 13%;">

                            <el-form-item prop="name">
                                <el-input v-model="from.name" style="width: 100%">
                                    <img slot="prefix" src="./assets/loginStatic/用户名.png"
                                        style="margin-top: 10px; margin-left: 7px;" />
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="password">
                                <el-input v-model="from.password" style="width: 100%" show-password>
                                    <img slot="prefix" src="./assets/loginStatic/密码.png"
                                        style="margin-top: 10px; margin-left: 7px;" />
                                </el-input>
                            </el-form-item>

                            <el-form-item style="margin-top: -12px;">
                                <el-checkbox v-model="from.remember" style="float: right;color:#fff">记住登录名</el-checkbox>
                            </el-form-item>

                            <el-form-item>
                                <el-button type="primary"
                                    style="width: 100%; height: 35px; font-weight: bold; font-size: 15px; background-color: #006e4b;"
                                    @click="Login">
                                    登 录</el-button>
                            </el-form-item>

                        </el-form>

                    </div>
					<div style="padding-bottom: 12%;height:1px"></div>
                </div>

            </div>
        <el-row style="text-align: center; margin-top: 2%;">
            <span style="font-size: 14px;">{{ copyright }}</span>
        </el-row>

    </div>
</template>

<script>
import axios from "axios";
import Bus from "./js/bus.js";
export default {
    data() {
        return {
            dialogVisible: false,
            copyright: "@20210428",
            from: {
                name: "",
                password: "",
                remember: false,
            },
            rules: {
                name: [{
                    required: true,
                    message: '请输入用户名!',
                    trigger: 'blur'
                }],
                password: [{
                    required: true,
                    message: '请输入密码!',
                    trigger: 'blur'
                }]
            }
        };
    },
    methods: {
        Login() {
            this.$refs["from"].validate((valid) => {
                if (valid) {

                    const url = this.$globals.http + "user/login";
                    axios.post(url, {
                        name: this.from.name,
                        pwd: this.from.password,
                        pc_end: 'pc',
                    }).then((response) => {
                        var code = response.data.code;
                        var data = response.data.data;

                        if (code === '200') {
                            this.$message.success("登录成功！");

                            //记住用户名
                            if (this.from.remember) {
                                this.$session.set("from", JSON.stringify(this.from));
                            }

                            //token
                            this.$globals.token = true;
                            this.$session.set("token", this.$globals.token);

                            //当前登陆人信息
                            this.$globals.user.id = data.id;
                            this.$globals.user.name = data.staff_name;
                            this.$globals.user.role_id = data.role_id;
                            this.$globals.user.staff_id = data.staff_id;
                            this.$globals.user.phone = data.phone;
                            this.$globals.user.mailbox = data.mailbox;
                            this.$globals.user.sysJurisdictionList = data.sysJurisdictionList;
                            this.$session.set("user", JSON.stringify(this.$globals.user));
                            this.goToMain();
                        } else {
                            this.$message.warning(data);
                        }
                    }).catch((error) => {
                        console.log(error)
                        this.$message.error("服务器未响应！请稍后重试");
                    })

                }
            });

        },
        goToMain() {
            Bus.$emit("fn", "Main");
            this.$router.replace("/Main");
        },
    },
    created() {
        //token
        if (this.$session.get("token") != undefined) {
            this.$globals.token = this.$session.get("token");
        }
        if (this.$globals.token) {
            this.goToMain();
        }

        //记住用户名
        if (this.$session.get("from") != undefined) {
            var data = JSON.parse(this.$session.get("from"));
            this.from.name = data.name;
            this.from.remember = data.remember;
        }

        //当前登陆人信息
        if (this.$session.get("user") != undefined) {
            var data = JSON.parse(this.$session.get("user"));
            this.$globals.user.id = data.id;
            this.$globals.user.name = data.name;
            this.$globals.user.role_id = data.role_id;
            this.$globals.user.staff_id = data.staff_id;
            this.$globals.user.phone = data.phone;
            this.$globals.user.mailbox = data.mailbox;
        }

    }
}
</script>

<style scoped="scoped">
>>>.el-input__inner {
    height: 35px;
    background-color:rgba(255,255,255,0.2);
}
    >>>.el-checkbox__input.is-checked+.el-checkbox__label{
    color:#fff!important;
}
>>>.el-form-item{
    margin-bottom: 10px;
}
/deep/ .el-form-item {
  background-color: unset !important;
}
/deep/ .el-input input {
  color: #fff !important;
}

>>>.el-button--primary {
    border-color: #006e4b;
}

>>>.el-button--primary:hover {
    border: 1px solid #0eaf7b;
}

>>>.el-input--prefix .el-input__inner {
    padding-left: 40px;
}

>>>.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #006e4b;
}

>>>.el-checkbox__input.is-checked .el-checkbox__inner,
>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006e4b;
    border-color: #006e4b;
}

>>>.el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #006e4b;
}

>>>.el-checkbox__inner:hover {
    border: 1px solid #006e4b;
}

>>>.el-input__inner:focus {
    border: 1px solid #006e4b;
}
</style>



// WEBPACK FOOTER //
// Login.vue?678ce35e